import React from 'react';

const GifGridBlock = ({ block }) => {
  if (!block.items || block.items.length === 0) return null;

  const gridClasses = `grid grid-cols-${block.columns || 2} gap-4 mb-6`;

  return (
    <div className={gridClasses}>
      {block.items.map(item => (
        <div key={item.id} className="text-center flex flex-col items-center">
          {item.gif && (
            <img
              src={item.gif.url}
              alt={item.gif.alt || item.word}
              className="max-w-xs w-3/4 h-auto rounded-lg mb-0"
            />
          )}
          {item.word && (
            <p className={`font-${item.style?.fontWeight || 'bold'} text-${item.style?.textSize || 'lg'} mt-0`}>
              {item.word}
            </p>
          )}
        </div>
      ))}
    </div>
  );
};

export default GifGridBlock;

